<template>
  <div class="tableHeight">
    <!-- table -->
    <el-table
      stripe
      v-loading="tableConfig.loading"
      @sort-change="isSortableAble"
      :data="tableConfig.tableData"
      style="width: 100%; height: 100%"
    >
      <template v-slot:empty>
        <img src="../../assets/images/nodata.png" alt="" />
      </template>
      <template v-for="(i, x) in rowList" :key="x">
        <el-table-column
          :label="i.label"
          :min-width="i.width"
          :align="i.cellStyle"
          :show-overflow-tooltip="i.isHide"
          :fixed="i.isFixed"
          :sortable="i.isSortable ? 'custom' : false"
          v-if="i.isShow"
          :property="i.propName"
        >
          <template #default="scope">
            <!-- 图标 -->
            <div v-if="i.type === '01'">
              <i
                class="iconfont wordColor itemIcon"
                @click="itemClick(i, scope.row)"
                :class="i.isEdit ? i.icon + ' ' + 'cursor' : i.icon"
              ></i>
            </div>

            <!-- 需要转换 -->
            <div v-if="i.type === '02'">
              <el-tag
                v-if="
                  $common.transformationFn(
                    this.dictionaryObj[i.dictionaryType],
                    scope.row[i.propName]
                  )
                "
                :type="i.extend.isEditType"
                effect="light"
              >
                <span
                  @click="itemClick(i, scope.row)"
                  :class="i.isEdit ? 'cursor' : ''"
                >
                  {{
                    $common.transformationFn(
                      this.dictionaryObj[i.dictionaryType],
                      scope.row[i.propName]
                    )
                  }}
                </span>
              </el-tag>
            </div>

            <!-- 文本 -->
            <div v-if="i.type === '03'">
              <span
                @click="itemClick(i, scope.row)"
                :class="i.isEdit ? 'cursor wordColor' : ''"
              >
                {{ scope.row[i.propName] }}
              </span>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- 显示列弹窗 -->
    <el-dialog
      title="自定义显示列"
      class="addDialog"
      center
      :model-value="dialogVisible"
      draggable
      :before-close="handleClose"
      width="70%"
      @open="open"
    >
      <div class="dialog-form">
        <el-table stripe :data="showList" style="width: 100%; height: 100%">
          <template v-slot:empty>
            <img src="../../assets/images/nodata.png" alt="" />
          </template>
          <el-table-column
            align="center"
            prop="label"
            label="显示列名称"
            :min-width="120"
          />
          <el-table-column
            align="center"
            prop="isShow"
            label="是否显示"
            :min-width="110"
          >
            <template #default="scope">
              <el-switch v-model="scope.row.isShow" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sortNo"
            label="排序号"
            :min-width="180"
          >
            <template #default="scope">
              <el-input-number
                class="inputWidth"
                v-model="scope.row.sortNo"
                :min="1"
              />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="width"
            label="宽度"
            :min-width="180"
          >
            <template #default="scope">
              <el-input-number
                class="inputWidth"
                v-model="scope.row.width"
                :min="60"
                :max="500"
              />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="isFixed"
            label="是否固定列"
            :min-width="110"
          >
            <template #default="scope">
              <el-switch v-model="scope.row.isFixed" />
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="isHide"
            label="超出是否隐藏"
            :min-width="110"
          >
            <template #default="scope">
              <el-switch v-model="scope.row.isHide" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 确定按钮 -->
      <template #footer>
        <span class="dialog-footer">
          <el-button v-dbclick type="primary" @click="submitFn" class="submit"
            >确定</el-button
          >
          <el-button @click="resettingList">重置</el-button>
          <el-button @click="handleClose">取消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { customcolumnsMe, dictionarySearch, customcolumnsBatch } from '@/api/api.js'
export default {
  name: 'tableModule',
  components: {},
  data () {
    return {
      dialogVisible: false,
      tableConfig: this.$store.state.tableConfig,
      rowList: [],
      showList: [],
      dictionaryObj: {}
    }
  },
  watch: {
  },
  computed: {
  },
  mounted () { },
  created () {
    this.loading = true
    this.getcustomcolumns()
  },
  methods: {
    // 获取所有列
    getcustomcolumns () {
      customcolumnsMe({
        menuCode: this.getMenuCode((this.$route.matched[this.$route.matched.length - 1]).path)
      }).then(res => {
        if (res.status === 200) {
          this.rowList = res.data
          this.dictionaryFn(res.data)
        } else {
          this.$message.warning('获取自定义列失败！')
        }
      }).catch(() => {
        this.$message.warning('获取自定义列失败！')
      })
    },
    // 根据路径获取code
    getMenuCode (path) {
      const arr = JSON.parse(sessionStorage.getItem('menuList'))
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].path === path) {
          return arr[i].code
        }
      }
    },
    // 点击排序时触发
    isSortableAble (e) {
      this.$emit('clickSort', e)
    },
    // 点击单元格
    itemClick (i, row) {
      if (i.isEdit) {
        this.$emit('clcikCells', row)
      }
    },
    // 关闭显示列弹窗
    handleClose () {
      this.dialogVisible = false
    },
    // 打开显示列弹窗
    handleShow () {
      this.dialogVisible = true
      this.showList = JSON.parse(JSON.stringify(this.rowList))
    },
    resettingList () {
      this.showList = JSON.parse(JSON.stringify(this.rowList))
    },
    // 显示列提交
    submitFn () {
      const arr = JSON.parse(JSON.stringify(this.showList))
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].tenantCode === '0' && arr[i].username === '0') {
          delete arr[i].code
          delete arr[i].id
          arr[i].username = this.$common.getStorage('users').username
          arr[i].tenantCode = this.$common.getStorage('users').tenantCode
        }
      }
      customcolumnsBatch(arr).then(res => {
        if (res.status === 200) {
          this.handleClose()
          this.getcustomcolumns()
        } else {
          this.$message.warning('修改失败')
        }
      }).catch(() => {
        this.$message.warning('修改失败')
      })
    },
    // 数据字典转换
    dictionaryFn (arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].type === '02') {
          dictionarySearch({ type: arr[i].dictionaryType }).then(res => {
            this.dictionaryObj[[arr[i].dictionaryType]] = res.data[0].content
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cursor {
  cursor: pointer;
}
</style>
